import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import reportservices from '../../services/report.service';
import CONSTANT from './../../../shared/constants/constant';
import Pagination from './../../../shared/components/pagination';
import CustomExpandableTable from './../../../shared/components/customExpandableTable';
import DatePicker from 'vue2-datepicker';
import Treeselect from '@riophae/vue-treeselect';
import Loader from './../../../shared/components/loader';
import XLSX from 'xlsx';

export default {
  name: 'handover',
  components: {
    Pagination,
    VueElementLoading,
    Treeselect,
    DatePicker,
    Loader,
    CustomExpandableTable
  },
  props: [],
  data() {
    return {
      pohdata: {},
      awb: '',
      handoverToDate: '',
      handoverFromDate: '',
      viewpohimage: false,
      isLoading: false,
      tableColumn: ['Awb', 'Handover type', 'Client Name', 'Booking mode', 'Handover date', 'POH'],
      handoveroptions: [
        { id: '1', label: 'Consignor drop' },
        { id: '2', label: 'Consignee pickup' },
      ],
      handoverType: null,
      tableItems: [],
      imageLoader: false,
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      offset: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
    }
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.hubId = userdetail.hubID[0];
    await this.getHandoverDetails();
  },
  methods: {
    search() {
      this.getHandoverDetails();
    },
    reset() {
      this.awb = '';
      this.handoverToDate = '';
      this.handoverFromDate = '';
      this.handoverType = null;
      this.currentPage = 1;
      this.totalPage = 0;
      this.offset = 0;
      this.getHandoverDetails();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getHandoverDetails();
    },
    async exportData() {
      try {
        var data = await this.getHandoverDetails(1);
        this.isLoading = true;
        console.log(data)
        if (data && data.data.code == 200) {
          var tempdata = [];
          data.data.data.rows.map((el, id) => {
            tempdata.push({
              'Sr No': id + 1,
              'Awb': el.awb,
              'Handover type': el.allocationtype == 1 ? "Consignor drop" : 'Consignee pickup',
              'Awb created date': el.awbcreateddate,
              "clientid": el.clientid,
              "clientbusinessaccountid": el.clientbusinessaccountid,
              'Client Name': el.clientname,
              "Booking source": el.bookingsource,
              "Booking mps count": el.bookingmpscount,
              'Booking mode': el.bookingmode,
              'POH image': el.allocationtype == 1 ? el.pohurl.pohimage[0] : el.pohurl.destinationpohimg[0],
              "pohrecievername": el.pohrecievername,
              "pohrecievermob": el.pohrecievermob,
              "originhubid": el.originhubid,
              "destinationhubid": el.destinationhubid,
              'Handover date': moment(el.handoverdate).tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss').valueOf()
            });
          })
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data1 = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data1, 'data')
          XLSX.writeFile(wb, dt + 'handoverReport.xlsx');
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    async getHandoverDetails(flag) {
      try {
        let input = {
          offset: this.offset,
          limit: this.pageLimit,
          hubid: this.hubId
        }
        if (flag) {
          input.exportflag = 1
        }
        if (this.awb) {
          input.awb = this.awb;
        }
        if (this.handoverToDate) {
          input.todate = this.handoverToDate;
        }
        if (this.handoverFromDate) {
          input.fromdate = this.handoverFromDate;
        }
        if (this.handoverType) {
          input.handovertype = this.handoverType;
        }
        this.isLoading = true;
        let data = await reportservices.getHandoverReportDetails(input);
        if (flag) return data;
        this.tableItems = [];
        if (data.data.code == 200) {
          this.totalCount = data.data.data.count;
          data.data.data.rows.map((el, index) => {
            this.tableItems.push({
              'id': el.id,
              'index': index,
              'Awb': el.awb,
              'Handover type': el.allocationtype == 1 ? "Consignor drop" : 'Consignee pickup',
              'Client Name': el.clientname,
              'Booking mode': el.bookingmode,
              'POH': el.allocationtype == 1  ? el.pohurl && el.pohurl.hasOwnProperty('pohimage') ?el.pohurl.pohimage[0]:null :el.pohurl && el.pohurl.hasOwnProperty('destinationpohimg')? el.pohurl.destinationpohimg[0]:null,
              'Handover date': moment(el.handoverdate).tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss').valueOf()
            })
          })
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    getCustomTableEvent(el) {
      this.viewpohimage = false;
      this.pohdata = this.tableItems[el.id];
      document.getElementById("image").src = '';
      document.getElementById("image").src = this.pohdata.POH;
      this.viewpohimage = true;
      // let image = document.getElementById('image');
      // this.imageLoader = true;
      // if(image.complete){
      //   this.imageLoader = false;
      // }else{
      //   image.onload = () => {
      //     this.imageLoader = false;
      //   };
      //   image.onerror = () => {
      //     this.imageLoader = false;
      //   }
      // }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/report/views/handover/handover.component.js